import {
  CREATE_INITIAL_TEST_URL,
  GET_INITIAL_TESTS_URL,
  GET_INITIAL_TEST_BY_ID_URL,
  UPDATE_INITIAL_TEST_URL,
} from "../apiurls/apiurls";
import Cookies from "js-cookie";

const getAuthToken = () => Cookies.get("admin_token");

const getHeaders = () => {
  const headers = { "Content-Type": "application/json" };
  const token = getAuthToken();
  if (token) {
    headers["Authorization"] = ` ${token}`;
  }
  return headers;
};

export const createInitialTest = async (payload) => {
  try {
    const response = await fetch(CREATE_INITIAL_TEST_URL, {
      method: "POST",
      headers: getHeaders(),
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error creating initial test:", error);
    throw error;
  }
};

export const getInitialTests = async (courseKey) => {
  try {
    const url =
      typeof courseKey === "string" && courseKey.trim()
        ? `${GET_INITIAL_TESTS_URL}?course_key=${encodeURIComponent(
            courseKey.trim()
          )}`
        : GET_INITIAL_TESTS_URL;

    const response = await fetch(url, {
      method: "GET",
      headers: getHeaders(),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching initial tests:", error);
    throw error;
  }
};

export const getInitialTestById = async (id) => {
  try {
    if (!id) {
      throw new Error("Test id is required to fetch initial test");
    }

    const url = `${GET_INITIAL_TEST_BY_ID_URL}?id=${encodeURIComponent(id)}`;

    const response = await fetch(url, {
      method: "GET",
      headers: getHeaders(),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching initial test by id:", error);
    throw error;
  }
};

export const updateInitialTest = async (id, payload) => {
  try {
    if (!id) {
      throw new Error("Test id is required to update initial test");
    }

    const url = `${UPDATE_INITIAL_TEST_URL}?id=${encodeURIComponent(id)}`;

    const response = await fetch(url, {
      method: "PUT",
      headers: getHeaders(),
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error updating initial test:", error);
    throw error;
  }
};
